export default "__VITE_ASSET__D0ma17OC__"